import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);


const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary2: colors.orange.base,
                primary: '#047aa9', //'#13c3e1',
                secondary2: colors.orange.lighten4,
                secondary: '#ddf3fd',
                accent: '#222222',
                error: colors.red.accent3,
            },
        },
        options: {
            customProperties: true,
        },
    },
    icons: {
        iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
})

export default vuetify
